import React, { useEffect, useRef } from "react";
import { currentTab } from "store/blogCategories";

const BlogFilter = ({ data }) => {
  const { current, switchTab } = currentTab();
  const tabList = useRef(null);

  const setInitialTab = () => {
    if (current === null) switchTab(data.tabs[0].title);
  }

  useEffect(() => {
    setInitialTab();
  }, []);

  return (
    <div className="py-11">
      <div className="container overflow-hidden">
        <div className="sm:overflow-x-auto w-full no-scrollbar py-1">
          <div
            className="border-0 border-b border-solid border-gray-400 relative z-[2] sm:border-0 flex items-center justify-center gap-14 sm:gap-10 sm:justify-center sm:w-fit"
            ref={tabList}
          >
            {data.tabs.map((tab, index) => (
              <div
                className={`blog-filters p-2.5 relative cursor-pointer ${
                  current == tab.title
                    ? "border-solid border-0 border-b-[3px] border-green-700 -bottom-0.5 z-[3] blog-filters--selected"
                    : ""
                }`}
                onClick={() => switchTab(tab.title)}
                key={index}
              >
                <h3
                  className={`paragraph-bold uppercase ${
                    current == tab.title ? "text-green-800" : "text-gray-400"
                  }`}
                >
                  {tab.title}
                </h3>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogFilter;
